// src/data/productCategories.js
export const productCategories = [
  {
    id: "acoustic-generator-enclosures",
    title: "Acoustic Generator Enclosures",
    shortDesc:
      "High-performance acoustic enclosures engineered to significantly reduce operational noise while ensuring ventilation, safety and service access.",
    images: [
      "https://lh3.googleusercontent.com/gps-cs-s/AG0ilSyZpVuZZLed0yM4omKVHiaQkXOG1eC5FVNIgrtDqOMI13eEzJfrUxP05J-S-6hABNU_R45Un7awUqryNrd8rQ0bp4Emh5U0CIHxIH7_MNa43Xjw4UaszwKTZLE4Y-5H76wlRxYppsd27d4=s1360-w1360-h1020-rw",
      "https://images.unsplash.com/photo-1593642532973-d31b6557fa68?q=80&w=1400&auto=format&fit=crop&ixlib=rb-4.0.3&s=70f5f3c15a0a6f6cb522f1c5d7bfa2d9",
    ],
    features: [
      "Industry-leading sound attenuation",
      "Thermal and weather resistant",
      "Easy maintenance & service doors",
      "Custom sizes & insulation packages",
    ],
    specifications: [
      { key: "Material", value: "Galvanized Mild Steel / Stainless Steel" },
      { key: "Noise Reduction", value: "Up to 25–35 dB(A) depending on spec" },
      { key: "IP Rating", value: "Up to IP55" },
      { key: "Finish", value: "Powder Coated (custom RAL)" },
    ],
    materials: [
      "Mild Steel (S235JR)",
      "Stainless Steel (SS304 / SS316 optional)",
      "Mineral Wool / Rockwool insulation",
      "Acoustic perforated linings",
    ],
    standards: ["ISO 9001:2015", "CE compliant design", "ISO 14001 (env)"],
    models: [
      {
        model: "AE-50",
        power: "Up to 50 kVA",
        datasheet: "/datasheets/AE-50.pdf",
      },
      {
        model: "AE-500",
        power: "Up to 500 kVA",
        datasheet: "/datasheets/AE-500.pdf",
      },
    ],
    applications: [
      "Power plants",
      "Hospitals & data centers",
      "Industrial sites",
      "Commercial complexes",
    ],
    certifications: ["ISO 9001", "CE Marking"],
    projectExamples: [
      {
        title: "Airport Backup Enclosure",
        image:
          "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?q=80&w=1400&auto=format&fit=crop&ixlib=rb-4.0.3&s=6ba3f0c5b7bccb1ee3f5e9f8e65ab274",
        link: "#",
      },
      {
        title: "Data Center Acoustic Canopy",
        image:
          "https://images.unsplash.com/photo-1496307042754-b4aa456c4a2d?q=80&w=1400&auto=format&fit=crop&ixlib=rb-4.0.3&s=ad3a2d593a1efb4f1c1d9b5077f6f294",
        link: "#",
      },
    ],
    datasheet: "/datasheets/acoustic-enclosures.pdf",
  },

  {
    id: "containerized-canopies",
    title: "Containerized Canopies",
    shortDesc:
      "Robust containerized canopies providing secure and transportable enclosures for gensets and equipment — ideal for offshore and remote power installations.",
    images: [
      "https://lh3.googleusercontent.com/gps-cs-s/AG0ilSyZpVuZZLed0yM4omKVHiaQkXOG1eC5FVNIgrtDqOMI13eEzJfrUxP05J-S-6hABNU_R45Un7awUqryNrd8rQ0bp4Emh5U0CIHxIH7_MNa43Xjw4UaszwKTZLE4Y-5H76wlRxYppsd27d4=s1360-w1360-h1020-rw",
    ],
    features: [
      "ISO container-compatible design",
      "Modular and stackable",
      "Weatherproof and lockable",
      "Integrated lifting points",
    ],
    specifications: [
      { key: "Material", value: "Corten / Structural Steel" },
      { key: "External Dimensions", value: "Custom (20'/40' options)" },
      { key: "Finish", value: "Marine grade coating available" },
    ],
    materials: [
      "Corten steel",
      "Marine-grade coatings",
      "Reinforced structural framing",
    ],
    standards: ["ISO 1161 (corner fittings)", "DNV options for offshore"],
    models: [
      { model: "CC-20", size: "20 ft", datasheet: "/datasheets/CC-20.pdf" },
      { model: "CC-40", size: "40 ft", datasheet: "/datasheets/CC-40.pdf" },
    ],
    applications: [
      "Marine / Offshore",
      "Temporary sites",
      "Emergency response",
    ],
    certifications: ["DNV Ready (optional)", "ISO 9001"],
    projectExamples: [
      {
        title: "Offshore Power Module",
        image:
          "https://images.unsplash.com/photo-1523413651479-597eb2da0ad6?q=80&w=1400&auto=format&fit=crop&ixlib=rb-4.0.3&s=5c1a93e6ca1bf1a1b2b8f8d4a3b7b1a4",
        link: "#",
      },
    ],
    datasheet: "/datasheets/containerized-canopies.pdf",
  },

  {
    id: "custom-generator-modules",
    title: "Custom Generator Modules",
    shortDesc:
      "Fully engineered generator modules tailored for specific site, environmental and acoustic requirements — built for reliability and easy integration.",
    images: [
      "https://lh3.googleusercontent.com/gps-cs-s/AG0ilSyZpVuZZLed0yM4omKVHiaQkXOG1eC5FVNIgrtDqOMI13eEzJfrUxP05J-S-6hABNU_R45Un7awUqryNrd8rQ0bp4Emh5U0CIHxIH7_MNa43Xjw4UaszwKTZLE4Y-5H76wlRxYppsd27d4=s1360-w1360-h1020-rw",
    ],
    features: [
      "Custom structural integration",
      "Thermal optimized design",
      "Integrated fuel & electrical interfaces",
      "Skid-mounted for easy installation",
    ],
    specifications: [
      { key: "Power Range", value: "50 kVA – 3500 kVA" },
      { key: "Frame", value: "Heavy Duty Steel Skid" },
      { key: "Cooling", value: "Air / Water options" },
    ],
    materials: [
      "Steel skids",
      "Anti-vibration mounts",
      "Fire-retardant panels",
    ],
    standards: ["ISO 9001", "CE compliant options"],
    models: [{ model: "GM-CUSTOM", note: "Fully tailored; request quote" }],
    applications: [
      "Utilities",
      "Heavy industry",
      "Data centers",
      "Construction",
    ],
    certifications: ["ISO 9001"],
    projectExamples: [
      {
        title: "Utility Backup Module",
        image:
          "https://images.unsplash.com/photo-1521805103152-6a8429b8afc0?q=80&w=1400&auto=format&fit=crop&ixlib=rb-4.0.3&s=4d2c3e2d2f1f2b3a4d5a6b7c8e9f0a1b",
        link: "#",
      },
    ],
    datasheet: "/datasheets/custom-generator-modules.pdf",
  },

  {
    id: "fuel-tanks",
    title: "Fuel Tanks",
    shortDesc:
      "High-integrity fuel tanks designed for safe storage, transport and stacking. Available in single and multi-chamber options with anti-corrosion treatment.",
    images: [
      "https://lh3.googleusercontent.com/gps-cs-s/AG0ilSyZpVuZZLed0yM4omKVHiaQkXOG1eC5FVNIgrtDqOMI13eEzJfrUxP05J-S-6hABNU_R45Un7awUqryNrd8rQ0bp4Emh5U0CIHxIH7_MNa43Xjw4UaszwKTZLE4Y-5H76wlRxYppsd27d4=s1360-w1360-h1020-rw",
    ],
    features: [
      "Stackable designs for space efficiency",
      "Secondary containment options",
      "Internal baffles and level gauges",
      "Coated for corrosion resistance",
    ],
    specifications: [
      { key: "Capacity", value: "500 L – 50,000 L" },
      { key: "Material", value: "Carbon Steel / SS options" },
      { key: "Finish", value: "Epoxy / Polyurethane coatings" },
    ],
    materials: ["Carbon steel", "SS316 lining (optional)", "Epoxy coatings"],
    standards: ["API 650 / API 620 (on request)", "ISO 9001"],
    models: [
      {
        model: "FT-500",
        capacity: "500 L",
        datasheet: "/datasheets/FT-500.pdf",
      },
      {
        model: "FT-5000",
        capacity: "5,000 L",
        datasheet: "/datasheets/FT-5000.pdf",
      },
    ],
    applications: ["Fuel storage depots", "Generators", "Fleet refueling"],
    certifications: ["API options available", "ISO 9001"],
    projectExamples: [
      {
        title: "Stackable Fuel Tank Farm",
        image:
          "https://images.unsplash.com/photo-1509395176047-4a66953fd231?q=80&w=1400&auto=format&fit=crop&ixlib=rb-4.0.3&s=b7d8c9e0f4a1b2c3d4e5f6a7b8c9d0e1",
        link: "#",
      },
    ],
    datasheet: "/datasheets/fuel-tanks.pdf",
  },

  {
    id: "stackable-fuel-tanks",
    title: "Stackable Fuel Tanks",
    shortDesc:
      "Efficient stackable tanks engineered for compact storage and safe handling — ideal for rental fleets, temporary sites and modular installations.",
    images: [
      "https://lh3.googleusercontent.com/gps-cs-s/AG0ilSyZpVuZZLed0yM4omKVHiaQkXOG1eC5FVNIgrtDqOMI13eEzJfrUxP05J-S-6hABNU_R45Un7awUqryNrd8rQ0bp4Emh5U0CIHxIH7_MNa43Xjw4UaszwKTZLE4Y-5H76wlRxYppsd27d4=s1360-w1360-h1020-rw",
    ],
    features: [
      "Interlocking base for safe stacking",
      "Integrated lifting lugs",
      "Quick-connect fuel lines",
      "Robust anti-corrosive finish",
    ],
    specifications: [
      { key: "Capacity", value: "250 L – 2,500 L" },
      { key: "Material", value: "Mild Steel with epoxy finish" },
    ],
    materials: ["Mild steel", "Reinforced corners", "Lifting points"],
    standards: ["ISO 9001"],
    models: [
      {
        model: "SFT-250",
        capacity: "250 L",
        datasheet: "/datasheets/SFT-250.pdf",
      },
    ],
    applications: ["Rental fleets", "Events", "Construction sites"],
    certifications: ["ISO 9001"],
    projectExamples: [],
    datasheet: "/datasheets/stackable-fuel-tanks.pdf",
  },

  {
    id: "offshore-oil-skid-frames",
    title: "Offshore Oil Skid Frames",
    shortDesc:
      "High-strength skid frames and modules purpose-built for offshore environments — corrosion protected and tested for marine deployment.",
    images: [
      "https://lh3.googleusercontent.com/gps-cs-s/AG0ilSyZpVuZZLed0yM4omKVHiaQkXOG1eC5FVNIgrtDqOMI13eEzJfrUxP05J-S-6hABNU_R45Un7awUqryNrd8rQ0bp4Emh5U0CIHxIH7_MNa43Xjw4UaszwKTZLE4Y-5H76wlRxYppsd27d4=s1360-w1360-h1020-rw",
    ],
    features: [
      "Marine-grade structural design",
      "Anti-seize and corrosion protection",
      "Customized lifting & mounting points",
    ],
    specifications: [
      { key: "Frame Material", value: "Duplex / Corten steel options" },
      { key: "Coatings", value: "Marine epoxy / zinc primers" },
    ],
    materials: ["Corten", "Duplex stainless steel", "Marine coatings"],
    standards: ["DNV / ABS on request", "ISO 9001"],
    models: [{ model: "OSF-1", note: "Custom built per project" }],
    applications: ["Offshore platforms", "Oil & gas installations"],
    certifications: ["DNV (optional)", "ISO 9001"],
    projectExamples: [
      {
        title: "Offshore Skid Integration",
        image:
          "https://images.unsplash.com/photo-1526406915891-6b2ef2f4e9c8?q=80&w=1400&auto=format&fit=crop&ixlib=rb-4.0.3&s=1a2b3c4d5e6f7a8b9c0d1e2f3a4b5c6d",
        link: "#",
      },
    ],
    datasheet: "/datasheets/offshore-skids.pdf",
  },

  {
    id: "pressure-vessels",
    title: "Pressure Vessels",
    shortDesc:
      "Engineered pressure vessels and tanks designed and fabricated to exacting standards for safe storage and process applications.",
    images: [
      "https://lh3.googleusercontent.com/gps-cs-s/AG0ilSyZpVuZZLed0yM4omKVHiaQkXOG1eC5FVNIgrtDqOMI13eEzJfrUxP05J-S-6hABNU_R45Un7awUqryNrd8rQ0bp4Emh5U0CIHxIH7_MNa43Xjw4UaszwKTZLE4Y-5H76wlRxYppsd27d4=s1360-w1360-h1020-rw",
    ],
    features: [
      "ASME / PED capable fabrication",
      "Hydrostatic testing available",
      "Multiple skirt / saddle designs",
    ],
    specifications: [
      { key: "Design Standard", value: "ASME VIII / PED (on request)" },
      { key: "Material", value: "Carbon Steel / Stainless Steel" },
    ],
    materials: ["Carbon steel", "Stainless steel 304/316", "Custom linings"],
    standards: ["ASME VIII (optional)", "PED (optional)"],
    models: [
      {
        model: "PV-STD",
        pressure: "Up to 50 bar",
        datasheet: "/datasheets/pv-std.pdf",
      },
    ],
    applications: ["Process plants", "Chemical industry", "Oil & gas"],
    certifications: ["ASME options", "ISO 9001"],
    projectExamples: [],
    datasheet: "/datasheets/pressure-vessels.pdf",
  },

  {
    id: "metal-structures",
    title: "Metal Structures",
    shortDesc:
      "Structural steel, platforms and bespoke metal architecture for industrial installations, buildings and process supports.",
    images: [
      "https://lh3.googleusercontent.com/gps-cs-s/AG0ilSyZpVuZZLed0yM4omKVHiaQkXOG1eC5FVNIgrtDqOMI13eEzJfrUxP05J-S-6hABNU_R45Un7awUqryNrd8rQ0bp4Emh5U0CIHxIH7_MNa43Xjw4UaszwKTZLE4Y-5H76wlRxYppsd27d4=s1360-w1360-h1020-rw",
    ],
    features: [
      "Large-span structural fabrication",
      "Precision welding & finishing",
      "Hot-dip galvanize / paint systems",
    ],
    specifications: [
      { key: "Capacity", value: "Up to large modular assemblies" },
      { key: "Welding", value: "SMAW / MIG / TIG as required" },
    ],
    materials: ["Structural steel (S355)", "Corten", "Aluminium (on request)"],
    standards: ["EN 1090 (CE) available", "ISO 9001"],
    models: [{ model: "STR-STD", note: "Project based quoting" }],
    applications: ["Buildings", "Platforms", "Bridges", "Walkways"],
    certifications: ["EN 1090 (on request)"],
    projectExamples: [
      {
        title: "Industrial Platform",
        image:
          "https://images.unsplash.com/photo-1503264116251-35a269479413?q=80&w=1400&auto=format&fit=crop&ixlib=rb-4.0.3&s=7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2e",
        link: "#",
      },
    ],
    datasheet: "/datasheets/metal-structures.pdf",
  },

  {
    id: "wastewater-solutions",
    title: "Wastewater Solutions",
    shortDesc:
      "Comprehensive fabricated metal solutions for wastewater treatment, including skids, tanks, and structural supports — engineered for durability and regulatory compliance.",
    images: [
      "https://lh3.googleusercontent.com/gps-cs-s/AG0ilSyZpVuZZLed0yM4omKVHiaQkXOG1eC5FVNIgrtDqOMI13eEzJfrUxP05J-S-6hABNU_R45Un7awUqryNrd8rQ0bp4Emh5U0CIHxIH7_MNa43Xjw4UaszwKTZLE4Y-5H76wlRxYppsd27d4=s1360-w1360-h1020-rw",
    ],
    features: [
      "Corrosion-resistant construction",
      "Modular skid-mounted treatment units",
      "Integrated instrumentation options",
    ],
    specifications: [
      { key: "Material", value: "SS316 / FRP options" },
      { key: "Capacity", value: "Project dependent" },
    ],
    materials: ["SS316", "FRP linings", "Chemical-resistant coatings"],
    standards: ["ISO 9001", "Local discharge standards compliance"],
    models: [{ model: "WWS-SKID", note: "Skid based solutions" }],
    applications: ["Municipal", "Industrial effluent", "Remote camps"],
    certifications: ["ISO 9001"],
    projectExamples: [],
    datasheet: "/datasheets/wastewater-solutions.pdf",
  },
];
